<template>
  <div class="px-7 py-5">
    <div class="heading-2 mb-5">Add Coupon</div>
    <div>
      <div class="heading-4">Who can use the code?</div>
      <div class="my-7">
        <v-select
          v-model="form.whoCanUseCode"
          :items="whoCanUseCode"
          attach
          multiple
          hint="Pick your favorite states"
          persistent-hint
          return-object
          label="Public/anyone"
          single-line
          background-color="#F6F8FC"
          color="black"
          flat
          hide-details
          solo
        ></v-select>
        <div class="error--text" v-if="$v.form.whoCanUseCode.$error">
          Please select atleast one option
        </div>
      </div>
      <div class="heading-4">What can this code be used for?</div>
      <div class="my-7">
        <v-select
          v-model="form.CodeUserFor"
          :items="CodeUserFor"
          multiple
          hint="Pick your favorite states"
          attach
          persistent-hint
          return-object
          label="Membership"
          single-line
          background-color="#F6F8FC"
          color="black"
          flat
          hide-details
          solo
        ></v-select>
        <div class="error--text" v-if="$v.form.CodeUserFor.$error">
          Please select atleast one option
        </div>
      </div>
      <div class="heading-4">Set discount type</div>
      <div class="my-7">
        <v-select
          v-model="form.DiscountType"
          :items="SetDiscountType"
          hint="Pick your favorite states"
          attach
          persistent-hint
          item-text="value"
          item-value="id"
          single-line
          background-color="#F6F8FC"
          color="black"
          flat
          hide-details
          solo
        ></v-select>
        <div class="error--text" v-if="$v.form.DiscountType.$error">
          Please select atleast one option
        </div>
      </div>

      <div class="my-7" v-if="form.DiscountType === 2">
        <div class="heading-4">Set value</div>
        <v-text-field
          v-model="form.DiscountValue"
          single-line
          background-color="#F6F8FC"
          color="black"
          flat
          type="number"
          hide-details
          append-icon="mdi-currency-usd"
          solo
        ></v-text-field>
        <div v-if="$v.form.DiscountValue.$error">
          <span class="red--text" v-if="!$v.form.DiscountValue.required"
            >Discount value is required.
          </span>
        </div>
        <p class="red--text" v-if="validationError">
          Value should be greater than 0 and less than 10000
        </p>
      </div>
      <div class="my-7" v-if="form.DiscountType === 1">
        <div class="heading-4">Set value</div>
        <v-text-field
          v-model="form.DiscountValue"
          single-line
          background-color="#F6F8FC"
          color="black"
          flat
          maxlength="3"
          type="number"
          hide-details
          append-icon="mdi-percent"
          solo
        ></v-text-field>
        <div v-if="$v.form.DiscountValue.$error">
          <span class="red--text" v-if="!$v.form.DiscountValue.required"
            >Discount value is required.
          </span>
        </div>
        <p class="red--text" v-if="validationError">{{ validationError }}</p>
      </div>

      <div class="mt-5">
        <v-row class="pa-1">
          <v-col
            cols="12"
            md="8"
            class="d-flex align-center justify-space-between"
          >
            <div class="index_h3 d-flex align-center">
              <span> Start Date</span>
            </div>
            <div class="index_h3">
              <v-text-field
                background-color="#F6F8FC"
                color="black"
                flat
                type="date"
                dense
                v-model="form.startDate"
                hide-details
                solo
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
        <div
          class="error--text"
          v-if="$v.form.startDate.$error && $v.form.startDate.dateIsSmaller"
        >
          Please select Start date
        </div>
        <div class="error--text" v-if="!$v.form.startDate.dateIsSmaller">
          Start date must be smaller than end date
        </div>
      </div>
      <div>
        <v-row class="pa-1">
          <v-col
            cols="12"
            md="8"
            class="d-flex align-center justify-space-between"
          >
            <div class="index_h3 d-flex align-center">
              <span> End Date</span>
            </div>
            <div class="index_h3">
              <v-text-field
                background-color="#F6F8FC"
                color="black"
                type="date"
                flat
                v-model="form.endDate"
                hide-details
                dense
                solo
              ></v-text-field>
            </div>
          </v-col>
        </v-row>
        <div
          class="error--text"
          v-if="$v.form.endDate.$error && $v.form.endDate.dateIsGreater"
        >
          Please select End date
        </div>
        <div class="error--text" v-if="!$v.form.endDate.dateIsGreater">
          End date must be greater than start date
        </div>
      </div>

      <div>
        <v-row class="pa-1">
          <v-col
            cols="12"
            md="8"
            class="d-flex align-center justify-space-between"
          >
            <div class="index_h3 d-flex align-center">
              <span>Code</span>
            </div>
            <div class="index_h3">
              <v-text-field
                background-color="#F6F8FC"
                color="black"
                flat
                v-model="form.code"
                :disabled="fieldDisableOnCheckBox == true"
                dense
                hide-details
                solo
              ></v-text-field>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="d-flex align-center">
            <b-form-checkbox
              v-model="fieldDisableOnCheckBox"
              @change="genrateAutoCode()"
            >
            </b-form-checkbox>

            <span class="text_style"> Generate Auto </span>
          </v-col>
        </v-row>
        <div class="error--text" v-if="$v.form.code.$error">
          Field is required
        </div>
        <div class="error--text" v-if="!$v.form.code.minLength">
          Code must have at least 10 digit
          {{ $v.form.code.$params.minLength.min }} letters.
        </div>
        <span v-if="existingCodes.includes(form.code)" class="error--text"
          >Code already exists</span
        >
      </div>
    </div>

    <div class="d-flex justify-end mt-5">
      <v-btn
        color="#C4C4C4"
        class="white--text py-5 px-8"
        depressed
        @click="close()"
        ><span class="text_style">Cancel</span>
      </v-btn>
      <v-btn
        color="primary"
        class="white--text py-5 px-8 ml-4"
        depressed
        :disabled="btnloader"
        @click="save()"
        ><span v-if="btnloader != true"> Save </span>
        <v-progress-circular
          indeterminate
          size="20"
          v-else
          class="px-5"
          color="white"
          v-show="btnloader"
        ></v-progress-circular
      ></v-btn>
    </div>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "EditCouponComponent",
  props: ["editCouponDialog", "GetSinglecoupon", "GetCoupon"],
  data() {
    return {
      existingCodes: [],
      btnloader: false,
      fieldDisableOnCheckBox: false,
      whoCanUseCode: [
        "Public/Anyone",
        "Access Member",
        "LifeScience Member",
        "Standard Member",
        "Practitioner Member",
        "Instructor",
      ],

      CodeUserFor: ["Membership", "IBA Courses ", " Store items", "Seminar items"],
      SetDiscountType: [
        { id: 1, value: "Percentage off" },
        { id: 2, value: "Dollar amount off" },
      ],
      form: {
        startDate: "",
        endDate: "",
        whoCanUseCode: "",
        CodeUserFor: "",
        DiscountType: 0,
        DiscountValue: null,
        code: "",
      },
      validationError: null,
    };
  },
  validations: {
    form: {
      code: {
        required,
        minLength: minLength(10),
      },
      startDate: {
        required,
        dateIsSmaller(value) {
          if (value && this.form.endDate) {
            return new Date(value) < new Date(this.form.endDate);
          }
          return true;
        },
      },
      endDate: {
        required,
        dateIsGreater(value) {
          if (value && this.form.startDate) {
            return new Date(value) > new Date(this.form.startDate);
          }
          return true;
        },
      },
      whoCanUseCode: { required },
      CodeUserFor: { required },
      DiscountType: { required },
      DiscountValue: {
        required,
      },
    },
  },
  watch: {
    "form.DiscountValue": function (newDiscountValue) {
      const regexPattern = /^(0|[1-9][0-9]?|100)$/;
      const regexPatternDollor = /^(0|[1-9]\d{0,3}|100000)$/;

      if (this.form.DiscountType === 1) {
        if (regexPattern.test(newDiscountValue)) {
          this.validationError = null;
        } else {
          this.validationError =
            "Please enter a valid number between 0 and 100.";
        }
      } else if (this.form.DiscountType === 2) {
        if (regexPatternDollor.test(newDiscountValue)) {
          this.validationError = null;
        } else {
          this.validationError =
            "Please enter a valid number between 0 and 100.";
        }
      }
    },
  },
  mounted() {
    this.form.whoCanUseCode = this.GetSinglecoupon.WhoCanUse.split(",");
    this.form.CodeUserFor = this.GetSinglecoupon.UsedFor.split(",");
    this.form.code = this.GetSinglecoupon.Code;
    this.form.startDate = this.GetSinglecoupon.StartDate.split("T", [1]);
    this.form.endDate = this.GetSinglecoupon.EndDate.split("T", [1]);
    this.form.DiscountType = this.GetSinglecoupon.DiscountType;
    this.form.DiscountValue = this.GetSinglecoupon.DiscountValue;
    this.couponId = this.genrateAutoCode.Id;
    this.existingCodes = this.GetCoupon.filter(
      (item) => item.Code !== this.GetSinglecoupon.Code
    ).map((item) => item.Code);
  },
  methods: {
    genrateAutoCode() {
      if (this.fieldDisableOnCheckBox) {
        let text = "";
        const possible =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var length = 10;
        for (let i = 0; i < length; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        this.form.code = text;
      }
    },
    close() {
      this.$emit("close");
    },
    save() {
      this.$v.$touch();
      if (this.$v.$invalid || this.existingCodes.includes(this.form.code)) {
        this.submitStatus = "ERROR";
      } else {
        var obj = {
          Code: this.form.code,
          DiscountType: this.form.DiscountType,
          DiscountValue: this.form.DiscountValue,
          StartDate: this.form.startDate.toString(),
          EndDate: this.form.endDate.toString(),
          UsedFor: this.form.CodeUserFor.toString(),
          WhoCanUse: this.form.whoCanUseCode.toString(),
          Id: this.GetSinglecoupon.Id,
        };
        this.btnloader = true;
        this.$store.dispatch("EditCoupon", obj).then((res) => {
          if (res.Status) {
            this.close();
            this.btnloader = false;
            this.snackbar = true;
            this.$emit("fetchData");
            this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Edited Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
          }
        });
      }
    },
  },
};
</script>

<style></style>
